/**
 * Check if one path is a super-path of another.
 *
 * Note: this implementation is probably grossly inefficient.
 * @param superPath
 * @param subPath
 * @returns
 */

import { FormPath } from '@tdp/common/form';

export function isSuperPath(superPath: FormPath, subPath: FormPath) {
  return superPath.every((part, index) => part === subPath[index]);
}
